import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo, FileSelectorViewModel } from "uicomponents";
import  { SetProductPriceView } from "./setProductPrice-view"

export class SetProductPriceViewModel extends WindowViewModel implements IPopup{
    public getTitle(): string {
        return 'تنظیم قیمت فروش';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.prices = ObservableArray.create<singleProductPrice>();
        this.loader = new ServerSideDataLoader(x=>this.refreshPaged(x));
        this.pricingProcessSelector = new AvailablePricingProcessSelectorViewModel(this);
        this.pricingProcessSelector.onSelectionChanged = w =>{
            this.pricingDomainId = w.id;
            this.warehouseId = w.warehouseId;
            this.pricingDomainName = w.title;
            this.refresh();
            this.fileSelector = new FileSelectorViewModel(this);
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new SetProductPriceView();
    }
    public getTypeId(): string {
        return "VM-25E0BCB7-54A1-41AB-90F2-6C44F784A170"
    }

    public set pricingProcessSelector(v: AvailablePricingProcessSelectorViewModel) { this._pricingProcessSelector = v; } public get pricingProcessSelector(): AvailablePricingProcessSelectorViewModel { return this._pricingProcessSelector;} private _pricingProcessSelector: AvailablePricingProcessSelectorViewModel;
    public set pricingDomainName(v: string) { this._pricingDomainName = v; } public get pricingDomainName(): string { return this._pricingDomainName;} private _pricingDomainName: string;
    public set pricingDomainId(v: string) { this._pricingDomainId = v; } public get pricingDomainId(): string { return this._pricingDomainId;} private _pricingDomainId: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set prices(v: ObservableArray<singleProductPrice>) { this._prices = v; } public get prices(): ObservableArray<singleProductPrice> { return this._prices;} private _prices: ObservableArray<singleProductPrice>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;

    async refresh(){
        this.loader.refresh();
    }
    closePopup() {}
    
    async refreshPaged(filteringInformation:any):Promise<PaginationInfo>{
        try {
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'خطا');
                throw verificationResult;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/GetAllProductCurrentFee',{
                FurtherQueryInfo :filteringInformation,
                WarehouseId : this.pricingDomainId
            });
            this.prices.update(...result.Products.map((x,i)=>{
                let r = new singleProductPrice(this);
                r.rowNumber = i + 1;
                r.productCode = x.ProductCode;
                r.productId = x.ProductId;
                r.measuredProductId = x.MeasuredProductId;
                r.productName = x.ProductName;
                r.productCarModel = x.ProductCarModel;
                r.unitId = x.UnitId;
                r.unitName = `${x.UnitName} (${x.UnitSymbol})`
                r.minPrice = x.MinFee;
                r.maxPrice = x.MaxFee;
                r.balance = x.StockBalance;
                r.availableBalance = x.AccessibleBalance;
                r.prices.update(...x.Prices.map(q=>{
                    let p = new singleSteppedPrice(r);
                    p.amount = q.Amount;
                    p.fee = q.Fee;
                    return p;
                }));
                if (r.prices.length == 0) {
                    let p = new singleSteppedPrice(r);
                    p.amount = 1;
                    r.prices.push(p);
                }
                r.updated = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async save(item:singleProductPrice){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/SetProductPrice',{
                WarehouseId : this.pricingDomainId,
                ProductId:item.productId,
                UnitId : item.unitId,
                Prices:item.prices.map(x=>{
                    return {
                        MinAmount:x.amount,
                        Fee:x.fee
                    };
                })
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('قیمت با موفقیت بروزسانی شد.','عملیات موفق');
            }else if(result.Faults && result.Faults[0] && result.Faults[0].Parameters && result.Faults[0].Parameters.FaultId.toString().toLowerCase()=='d1f58bf9-a9ca-4ce6-8033-d04af5aa4c7b'){
                await this.messageBoxConfirmWarning('امکان ثنظیم قیمت در زمان باز بودن شعبه وجود ندارد.','خطا');
            }else{
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            }
            return result;
        } catch (ex) {
            if(ex.FaultId && ex.FaultId.toString().toLowerCase()=='d1f58bf9-a9ca-4ce6-8033-d04af5aa4c7b'){
                await this.messageBoxConfirmWarning('امکان ثنظیم قیمت در زمان باز بودن شعبه وجود ندارد.','خطا');
            }else{
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            }
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }

    verify():string[] {
        let errors :string[]= [];
        if(stringIsNullOrEmpty(this.pricingDomainId)){
            errors.push('محدوده قیمت گذاری مشخص نشده است.');
        }
        return errors;
    }

    async export(){
        try {
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'خطا');
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/ExportProductPricesIntoExcelFile',{
                WarehouseId : this.warehouseId,
                PricingDomainId : this.pricingDomainId,
            });
            downloadFile(result.ExcelFile, `export_prices_${this.pricingDomainName}.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(stringIsNullOrEmpty(this.pricingDomainId)){
                errors.push('محدوده قیمت گذاری مشخص نشده است.');
            }
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/GetProductsFromExcel',{
                ExcelFile : this.fileSelector.filecontent
            });
            let popup = new Verification(this);
            popup.importedPrices.update(...result.Products.map(x=>{
                let r = new singleProductPrice(this);
                r.productCode = x.ProductCode;
                r.measuredProductId = x.MeasuredProductId;
                r.minPrice = x.Price;
                r.isFound = x.IsFound;
                return r;
            }));
            this.showPopup(popup);
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async acceptImport(productPrices: ObservableArray<singleProductPrice>){
        try {
            this.isLoading = true;
            let importProductPrices = productPrices.filter(x => x.isFound);
            let result = await ServerConnection.callServer('/Complex/FinancialServices/SetBatchOfProductPricesFromExcel',{
                pricingDomainId : this.pricingDomainId,
                ProductPrices : importProductPrices.map(x => {
                    return {
                        MeasuredProductId : x.measuredProductId,
                        Price : x.minPrice
                    }
                })
            });
            await this.messageBoxConfirmSuccess('قیمت ها با موفقیت بروزسانی شد.','عملیات موفق');
            this.refresh();
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class Verification extends ViewModel implements IPopup{
    public getTypeId(): string {return 'verification';}
    public GetDefaultView(): View<ViewModel> {return null;}
    closePopup() {}
    constructor(parent:SetProductPriceViewModel) {
        super(parent);
        this._parent = parent;
        this.importedPrices = ObservableArray.create<singleProductPrice>();
    }

    public set importedPrices(v: ObservableArray<singleProductPrice>) { this._importedPrices = v; } public get importedPrices(): ObservableArray<singleProductPrice> { return this._importedPrices;} private _importedPrices: ObservableArray<singleProductPrice>;

    private _parent : SetProductPriceViewModel;

    async accept(){
        this._parent.acceptImport(this.importedPrices);
        this.closePopup();
    }
}

export class singleProductPrice extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<SetProductPriceViewModel> {return null;}
    constructor(parent:SetProductPriceViewModel) {
        super(parent);
        this._typedParent = parent;
        this.prices = ObservableArray.create<singleSteppedPrice>();
    }
    private _typedParent : SetProductPriceViewModel;
    
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set unitId(v: string) { this._unitId = v; } public get unitId(): string { return this._unitId;} private _unitId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance;} private _availableBalance: number;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isDone(v: boolean) { this._isDone = v; } public get isDone(): boolean { return this._isDone;} private _isDone: boolean;
    public set isFailed(v: boolean) { this._isFailed = v; } public get isFailed(): boolean { return this._isFailed;} private _isFailed: boolean;
    public set prices(v: ObservableArray<singleSteppedPrice>) { this._prices = v; } public get prices(): ObservableArray<singleSteppedPrice> { return this._prices;} private _prices: ObservableArray<singleSteppedPrice>;
    public set minPrice(v: number) { this._minPrice = getAsNumber(v,true); } public get minPrice(): number { return this._minPrice;} private _minPrice: number;
    public set maxPrice(v: number) { this._maxPrice = v; } public get maxPrice(): number { return this._maxPrice;} private _maxPrice: number;
    public set isFound(v: boolean) { this._isFound = v; } public get isFound(): boolean { return this._isFound;} private _isFound: boolean;
    public set updated(v: boolean) { this._updated = v; } public get updated(): boolean { return this._updated;} private _updated: boolean;
    
    verify():string[]{
        let result :string[] =[];
        let price = this.prices.filter(q=>q.amount == 1)[0];
        if (typeof price === 'undefined') 
            result.push('قیمت مشخص نشده است.');
        if (typeof price !== 'undefined' && price.fee <= 0) 
            result.push('قیمت نامعتبر است.');
        return result;
    }
    
    async confirm(){
        try {
            this.isLoading = true;
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت قیمت');
                return;
            }
            this.isDone = false;
            this.isFailed = false;
            let result = await this._typedParent.save(this);
            if(result.IsSuccessful){
                this.isDone = true;
                this.updated = false;
                this.minPrice = this.prices.filter(q=>q.amount == 1)[0].fee;
            }else{
                this.isFailed = true;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    reset(){
    }
    remove(item:singleSteppedPrice){
        this.prices.remove(item);
    }
    add(){
        let item = new singleSteppedPrice(this);
        this.prices.push(item);
    }
}

export class singleSteppedPrice extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:singleProductPrice) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent:singleProductPrice;
    public set amount(v: number) { 
        this._amount = getAsNumber(v,true); 
        this.updateParentChangeStatus(); 
    } public get amount(): number { return this._amount;} private _amount: number;
    public set fee(v: number) { 
        this._fee =getAsNumber(v, true); 
        this.updateParentChangeStatus();
    } public get fee(): number { return this._fee;} private _fee: number;
    updateParentChangeStatus(){
        this._typedParent.updated = true;
        this._typedParent.isDone = false;
        this._typedParent.isFailed = false;
    }
    remove(){
        this._typedParent.remove(this)
    }
}

export class AvailablePricingProcessSelectorViewModel extends SelectorBaseViewModel<PricingProcessDomain>{
    protected async loadData(): Promise<PricingProcessDomain[]> {
        let result = await ServerConnection.callServer('/Complex/FinancialServices/GetAvailablePricingProcessDomain',{});
        return result.PricingProcessDomains.map(q=>{
            let result = new PricingProcessDomain(this);
            result.id = q.DomainId;
            result.warehouseId = q.WarehouseId;
            result.title = q.DomainName;
            return result;
        });
    }

}

class PricingProcessDomain extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}